// Builds an absolute URL to the native CreativeWizard (EditAdCreative) surface
// for a creative. The app router mounts under the `/builder` basename
// (see components/router/router.tsx) with the route
// `/:businessID/creatives/:creativeID`. Centralized here so a future basename
// change is a single edit, and so packet hosts can route `creative` comment
// deep-links to CreativeWizard instead of the packet URL.
export const creativeWizardUrl = (businessID: number, creativeID: string | number): string =>
  `${window.location.origin}/builder/${businessID}/creatives/${creativeID}`
